import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { firestore } from 'services/firebase/client';
import {
  normalizeSubscriptionCode,
  type SubscriptionCodeValidationResult,
  validateSubscriptionCode,
} from 'services/firebase/subscriptionCodeService';

export async function applyValidatedSubscriptionCodeToUser(
  userId: string,
  codeResult: SubscriptionCodeValidationResult,
): Promise<void> {
  const userRef = doc(firestore, 'subscription_users', userId);
  const userSnap = await getDoc(userRef);
  const data = userSnap.data();

  if (codeResult.type === 'referral' && codeResult.referrerId !== userId) {
    if (!data?.referredBy) {
      await updateDoc(userRef, { referredBy: codeResult.referrerId });
    }
    return;
  }

  if (codeResult.type === 'promo') {
    await updateDoc(userRef, {
      usedPromoCode: codeResult.promo.code,
      promoExtraBeers: codeResult.promo.extraBeers,
      promoExtraBeersMonths: codeResult.promo.months,
    });
  }
}

export async function applySubscriptionCodeToUser(
  userId: string,
  code: string,
): Promise<void> {
  const normalized = normalizeSubscriptionCode(code);
  if (!normalized) return;

  const codeResult = await validateSubscriptionCode(normalized);
  if (!codeResult) return;

  await applyValidatedSubscriptionCodeToUser(userId, codeResult);
}
